<div class="legal-page">
  <div class="legal-hero">
    <div class="legal-hero__bg"></div>
    <div class="legal-hero__content">
      <a class="legal-hero__back" routerLink="/home">
        <i class="fas fa-arrow-left"></i> Retour a l'accueil
      </a>
      <div class="legal-hero__icon"><i class="fas fa-lock"></i></div>
      <h1>Politique de Confidentialite</h1>
      <p class="legal-hero__subtitle">Comment nous collectons, utilisons et protegeons vos donnees personnelles</p>
    </div>
  </div>

  <div class="legal-body">
    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-database"></i></div>
        <h2>1. Collecte des donnees</h2>
      </div>
      <div class="legal-card__body">
        <p>Nous collectons les donnees suivantes dans le cadre de l'utilisation de l'application BeeKids :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> Nom, prenom, adresse email, numero de telephone</li>
          <li><i class="fas fa-check-circle"></i> Numero CIN (Carte d'Identite Nationale)</li>
          <li><i class="fas fa-check-circle"></i> Donnees de connexion (adresse IP, navigateur, systeme d'exploitation)</li>
          <li><i class="fas fa-check-circle"></i> Donnees de localisation de l'etablissement</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-cogs"></i></div>
        <h2>2. Utilisation des donnees</h2>
      </div>
      <div class="legal-card__body">
        <p>Les donnees collectees sont utilisees pour :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> La gestion des comptes utilisateurs et des etablissements</li>
          <li><i class="fas fa-check-circle"></i> Le suivi pedagogique des enfants</li>
          <li><i class="fas fa-check-circle"></i> La gestion des presences, menus, evenements et messagerie</li>
          <li><i class="fas fa-check-circle"></i> L'envoi de notifications et de communications</li>
          <li><i class="fas fa-check-circle"></i> L'amelioration de nos services</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-balance-scale"></i></div>
        <h2>3. Base legale du traitement</h2>
      </div>
      <div class="legal-card__body">
        <p>Le traitement de vos donnees est fonde sur :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> L'execution du contrat de service</li>
          <li><i class="fas fa-check-circle"></i> Votre consentement explicite</li>
          <li><i class="fas fa-check-circle"></i> L'interet legitime de l'editeur</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-clock"></i></div>
        <h2>4. Duree de conservation</h2>
      </div>
      <div class="legal-card__body">
        <p>Vos donnees sont conservees pendant la duree de votre compte actif, puis supprimees dans un delai de 30 jours apres la fermeture du compte, sauf obligation legale contraire.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-user-check"></i></div>
        <h2>5. Droits des utilisateurs</h2>
      </div>
      <div class="legal-card__body">
        <p>Conformement au RGPD et a la loi tunisienne 2018-50, vous disposez des droits suivants :</p>
        <div class="legal-rights-grid">
          <div class="legal-right-badge">
            <i class="fas fa-eye"></i>
            <span>Droit d'acces</span>
          </div>
          <div class="legal-right-badge">
            <i class="fas fa-edit"></i>
            <span>Rectification</span>
          </div>
          <div class="legal-right-badge">
            <i class="fas fa-trash-alt"></i>
            <span>Effacement</span>
          </div>
          <div class="legal-right-badge">
            <i class="fas fa-exchange-alt"></i>
            <span>Portabilite</span>
          </div>
          <div class="legal-right-badge">
            <i class="fas fa-ban"></i>
            <span>Opposition</span>
          </div>
        </div>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-share-alt"></i></div>
        <h2>6. Partage des donnees</h2>
      </div>
      <div class="legal-card__body">
        <p>Nous ne vendons jamais vos donnees personnelles. Elles peuvent etre partagees avec :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> Les prestataires techniques hebergeant l'application</li>
          <li><i class="fas fa-check-circle"></i> Les autorites competentes en cas d'obligation legale</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-envelope-open-text"></i></div>
        <h2>7. Contact</h2>
      </div>
      <div class="legal-card__body">
        <p>Pour toute question relative a la confidentialite :</p>
        <a class="legal-card__cta" href="mailto:privacy@beekids.tn">
          <i class="fas fa-envelope"></i> privacy&#64;beekids.tn
        </a>
      </div>
    </div>
  </div>
</div>
